import React from 'react';
import WrappedBase from './WrappedBase';

import MembershipToggle from '../containers/MembershipToggle';

export default class MembershipToggleWrapped extends React.Component {
  render() {
    return (
      <WrappedBase>
        <MembershipToggle {...this.props} />
      </WrappedBase>
    );
  }
}
